<page-toolbar [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading && !!errorLog">
  <mat-card appearance="outlined">
    <mat-card-title><h5>Details:</h5></mat-card-title>
    <mat-list>
      <mat-list-item>Error Status: {{errorLog.errorStatus}}</mat-list-item>
      <mat-list-item>Error Type: {{errorLog.errorType}}</mat-list-item>
      <mat-list-item>Occurence: {{errorLog.route}}</mat-list-item>
      <mat-list-item *ngIf="errorLog.destination">DestinationID: {{errorLog.destination}}</mat-list-item>
      <mat-list-item *ngIf="errorLog.language">Language: {{errorLog.language}}</mat-list-item>
      <mat-list-item *ngIf="errorLog.tweebieMode">Tweebie Mode: {{errorLog.tweebieMode}}</mat-list-item>
      <mat-list-item *ngIf="errorLog.kiosk">Kiosk Mode: {{errorLog.kiosk}}</mat-list-item>
      <mat-list-item *ngIf="errorLog.environment">Environment: {{errorLog.environment}}</mat-list-item>
      <mat-list-item>Date: {{errorLog.created| date: 'dd.MM.yyyy HH:MM'}}</mat-list-item>
    </mat-list>
    <mat-card appearance="outlined">
      <mat-card-title>Message:</mat-card-title>
      {{errorLog.errorMessage}}
    </mat-card>
    <div class="spacer"></div>
    <mat-card appearance="outlined" *ngIf="!!errorLog.errorStack && stackIsArray">
      <mat-card-title>Stack:</mat-card-title>
      <ng-container *ngFor="let stack of errorLog.errorStack">{{stack.functionName}}: ({{stack.lineNumber}}[{{stack.columnNumber}}
        ]) {{stack.fileName}}<br></ng-container>
    </mat-card>
    <mat-card appearance="outlined" *ngIf="!!errorLog.errorStack && !stackIsArray">
      <mat-card-title>Stack:</mat-card-title>
      {{errorLog.errorStack}}
    </mat-card>
  </mat-card>

  <div class="spacer"></div>

  <mat-card appearance="outlined">
    <mat-card-title>User:</mat-card-title>
    <mat-list>
      <mat-list-item *ngIf="errorLog.userName">User Name: {{errorLog.userName}}</mat-list-item>
      <mat-list-item *ngIf="errorLog.userType">User Type: {{errorLog.userType}}</mat-list-item>
      <mat-list-item *ngIf="errorLog.org">Organisation: {{errorLog.org}}</mat-list-item>

      <mat-list-item>Id: {{errorLog.userId}}</mat-list-item>
      <ng-container *ngIf="profile">
        <mat-list-item *ngIf="profile.firstName">Firstname: {{profile.firstName}}</mat-list-item>
        <mat-list-item *ngIf="profile.lastName">Lastname: {{profile.lastName}}</mat-list-item>
        <mat-list-item *ngIf="profile.email">E-mail: {{profile.email}}</mat-list-item>
        <mat-list-item *ngIf="profile.currentLanguage">Current language: {{profile.currentLanguage}}</mat-list-item>
      </ng-container>

    </mat-list>
    <mat-card appearance="outlined">
      <mat-card-title>User Agent</mat-card-title>
      {{errorLog.userAgent}}
    </mat-card>
  </mat-card>
</page-content>
